"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PHONE = "@media (max-width: 640px)";
const NO_MOTION = "@media (prefers-reduced-motion: reduce)";
const toastIn = "x1x235tc-B";
const toastOut = "x1jn504y-B";
const styles = exports.styles = {
  stack: {
    position: "xixxii4",
    bottom: "xexjinp xemcbt5",
    left: "x1nrll8i x1phvrq5",
    insetInlineStart: null,
    insetInlineEnd: null,
    right: "xwukr4l x1etikn3",
    transform: "xuuh30 x1mji7za",
    zIndex: "x8k05lb",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4 x1o3peri",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    pointerEvents: "x47corl",
    $$css: true
  },
  toast: {
    pointerEvents: "x67bb7w",
    display: "x78zum5",
    alignItems: "x6s0dn4",
    flexWrap: "x1a02dak",
    gap: "x16txp7y",
    rowGap: null,
    columnGap: null,
    boxSizing: "x9f619",
    backgroundColor: "xidafa1",
    color: "x1f7m26b",
    fontFamily: "x1wl88yq",
    fontSize: "x1jchvi3",
    lineHeight: "xwn7fz2",
    paddingTop: "x1o9s02k",
    paddingBottom: "xt307pa",
    paddingLeft: "xvrd65f",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x232j3d",
    borderRadius: "x1e6avla",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    boxShadow: "x19ku80y",
    maxWidth: "x17s898u xeyi6kz",
    cursor: "xt0e3qv",
    animationName: "xvbdl32 x1aquc0h",
    animationDuration: "x5hsz1j",
    animationTimingFunction: "x1y1npqo",
    $$css: true
  },
  toastWithAction: {
    borderRadius: "xfm794m",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingRight: "x1arb9wb",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingTop: "xi1zy7b",
    paddingBottom: "xvrpxjx",
    $$css: true
  },
  toastLeaving: {
    animationName: "xxp0q0x x1aquc0h",
    animationDuration: "xllfotl",
    animationTimingFunction: "xn0cd8s",
    animationFillMode: "x10e4vud",
    $$css: true
  },
  message: {
    flexGrow: "x1iyjqo2",
    minWidth: "xeuugli",
    paddingTop: "x1hqevxg",
    paddingBottom: "xn2xpo4",
    $$css: true
  },
  action: {
    minHeight: "x1w8wqur",
    paddingLeft: "x14ffaay",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x1afqadn",
    fontFamily: "x1wl88yq",
    fontSize: "x1jchvi3",
    fontWeight: "x1s688f",
    color: "xssbz8f x10phpnj",
    backgroundColor: "xjbqb8w",
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderRadius: "x116uinm",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    cursor: "x1ypdohk",
    transition: "xdvs2vg",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    outlineWidth: "x1k57tk5 x784prv",
    outlineStyle: "xaatb59",
    outlineColor: "x1ixfmrq",
    outlineOffset: "x2ssjo2",
    $$css: true
  },
  actionPending: {
    opacity: "x197sbye",
    cursor: "x19v85br",
    $$css: true
  },
  dismiss: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    width: "xb1qrhf",
    minHeight: "x1w8wqur",
    color: "xa2uak6 x10phpnj",
    backgroundColor: "xjbqb8w",
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderRadius: "x116uinm",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    cursor: "x1ypdohk",
    transition: "xdvs2vg",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    outlineWidth: "x1k57tk5 x784prv",
    outlineStyle: "xaatb59",
    outlineColor: "x1ixfmrq",
    outlineOffset: "x2ssjo2",
    $$css: true
  }
};